<div (click)="focus()" class="row rounded-2 background-light-gray pointer pointer-hover-blue m-1 p-2">
    <div class="col-2 m-auto">
        <app-water-point-svg
            [lastAssetSample]="lastAssetSample()"
            class="img-fluid img-max m-auto"></app-water-point-svg>
    </div>
    <div class="col-10 m-auto">
        <div class="row m-auto">
            <app-spinner [loading]="loading"></app-spinner>
            @if (!loading) {
                <div class="fw-bold text-truncate">{{ asset()?.name || '-' }}</div>
                <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
                <div class="{{ valueColorClass }}">Level: {{ percentage }}</div>
            }
            @if (asset()?.synchronizationStatus === SynchronizationStatus.syncPending) {
                <span><i class="fa-solid fa-hourglass-half color-warning"></i></span>
            }
        </div>
    </div>
</div>
